import api from './api';
import type { Notification, NotificationListResponse } from '@/types';

interface GetNotificationsParams {
  page?: number;
  per_page?: number;
  unread?: boolean;
  read?: boolean;
  type?: string;
}

export const notificationService = {
  // Get notifications list
  async getNotifications(params: GetNotificationsParams = {}): Promise<NotificationListResponse> {
    const queryParams: Record<string, string> = {};

    if (params.page) queryParams.page = String(params.page);
    if (params.per_page) queryParams.per_page = String(params.per_page);
    if (params.unread) queryParams.unread = 'true';
    if (params.read) queryParams.read = 'true';
    if (params.type) queryParams.type = params.type;

    const response = await api.get('/notifications', { params: queryParams });
    return response.data;
  },

  // Get single notification
  async getNotification(id: string): Promise<{ data: Notification }> {
    const response = await api.get(`/notifications/${id}`);
    return response.data;
  },

  // Get unread count
  async getUnreadCount(): Promise<{ data: { unread_count: number } }> {
    const response = await api.get('/notifications/unread_count');
    return response.data;
  },

  // Mark notification as read
  async markAsRead(id: string): Promise<{ data: Notification }> {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
  },

  // Mark all notifications as read
  async markAllAsRead(): Promise<{ data: { message: string } }> {
    const response = await api.post('/notifications/read_all');
    return response.data;
  },

  // Delete notification
  async deleteNotification(id: string): Promise<{ data: { message: string } }> {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },

  // Delete all notifications
  async deleteAllNotifications(readOnly: boolean = false): Promise<{ data: { message: string } }> {
    const response = await api.delete('/notifications/destroy_all', {
      params: readOnly ? { read_only: 'true' } : {},
    });
    return response.data;
  },
};

export default notificationService;
